import { makeStyles } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
	main: {
		display: 'flex',
		flexDirection: 'column',
		width: 277,
		padding: theme.spacing(2),
	},
	line: {
		display: 'flex',
		flexDirection: 'column',
	},
	title: {
		height: 35,
		width: 277,
		color: '#757575',
		fontSize: 14,
		lineHeight: '18px',
	},
	data: {
		height: 35,
		color: 'rgba(0, 0, 0, 0.9)',
		fontSize: 14,
		letterSpacing: '0.25px',
		lineHeight: '3px',
	},
}));

interface Props extends WithTranslation {
	IBAN?: string;
	BIC: string;
	Bank: string;
}

const BankInfo: FunctionComponent<Props> = (props) => {
	const classes = useStyles();
	const bankInfoLine = (title: string, data: string) => (
		<div className={classes.line}>
			<div className={classes.title}>{title}</div>
			<div className={classes.data}>{data}</div>
		</div>
	);

	return (
		<div data-cy="bank_info_main" className={classes.main}>
			{props.IBAN && bankInfoLine(props.t('payment.IBAN'), props.IBAN)}
			{bankInfoLine(props.t('payment.BIC'), props.BIC)}
			{bankInfoLine(props.t('payment.Bank'), props.Bank)}
		</div>
	);
};

export default withTranslation('translation')(BankInfo);
